import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence } from 'framer-motion';

import { OverlayModal } from '@/components/Modals/OverlayModal/OverlayModal';
import { H2, StringSmall } from '@/components/Typography/Typography';
import { toNextPromoReward } from '@/redux/reducers/shopReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { ClaimPromoCodeReward } from './ClaimPromoCodeReward';
import { PromoCodeReward } from './PromoCodeReward';

const PromoCodeRewardModal: FC = () => {
  const activeRewardIndex = useAppSelector(
    (state) => state.shop.promoCode.activeRewardIndex,
  );
  const activeReward = useAppSelector((state) =>
    activeRewardIndex !== null
      ? state.shop.promoCode.rewards[activeRewardIndex]
      : undefined,
  );
  const dispatch = useAppDispatch();

  const onClose = (): void => {
    dispatch(toNextPromoReward());
  };

  const { t } = useTranslation();

  return (
    <AnimatePresence mode="wait">
      {activeReward && (
        <OverlayModal
          key={activeReward.item + activeReward.value}
          className="flex flex-col items-center justify-center"
          onClose={onClose}
        >
          <H2 weight="bold" className="mb-2">
            {t('Promo code activated!')}
          </H2>
          <StringSmall className="!text-white/80 mb-10">
            {t('Congratulations! Reward unlocked!')}
          </StringSmall>
          <PromoCodeReward {...activeReward} />
          <ClaimPromoCodeReward />
        </OverlayModal>
      )}
    </AnimatePresence>
  );
};

export { PromoCodeRewardModal };
